import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, ButtonFav, ButtonsContainer, Form, InputContainer } from "../DepositElements";
import DatosRetiro from "./DatosRetiro";
import ModalFav from "./ModalFav";
import { API_URL } from "../../../const/api";
import axios from "axios";
import { useSelector } from "react-redux";
import { selectId, selectUser, selectCurrency } from "../../../features/user/userSlice";
import { successNotification } from "../../../utils/toastNotifications";
import { getFormFavoritos } from "../../../utils/tools";

const FormWithdraw = ({
  bancoTipo,
  handleBanco,
  cuentas,
  moneda,
  form,
  setForm,
  handleChange,
  clearForm,
  handleClose,
  solicitarRetiro,
  loading,
}) => {
  const [t] = useTranslation("global");
  const id_uo = useSelector(selectId);
  const [openModalFav, setOpenModalFav] = useState(false)
  const [favorites, setFavorites] = useState([]);
  const monedalocal = useSelector(selectCurrency);
  const user = useSelector(selectUser);

  const handleSelectFav = (item) => {
    const aux = getFormFavoritos(item.detalle);
    if(bancoTipo) {
       setForm(aux)
      } else {
      const detalle = item.detalle.split('=');
      const e = {target: {value: item.tipo+'-'+detalle[0]}}
      handleBanco(e)
      setTimeout(()=>{
        setForm(aux)
      },500)
    }

    handleCloseFav()
  }

  const handleOpenModalFav = async () => {
    const res = await axios.post(API_URL+'getFavoritoRetiro', {id_uo});
    const data = res.data.response;
    if(bancoTipo) {
      const favsFilter = data.filter(x=>x.tipo.toLowerCase()===bancoTipo.toLowerCase().split('-')[0])
      setFavorites(favsFilter)
    } else {
      setFavorites(data)
    }
    setOpenModalFav(true)
  } 

  const handleDeleteFav = async (id) => {
    const res = await axios.post(API_URL+'deleteFavorito', {id});
    const data = res.data.response;
    if(data) {
      let newFav = favorites.filter(x=>x.id!==id)
      setFavorites(newFav)
      successNotification("Se ha eliminado este método de pago favorito")
    } else {
      successNotification("Ocurrió un error eliminando el método de pago favorito")
    }
  }

  const handleCloseFav = () => {
    setOpenModalFav(false)
  }

  return (
    <>
    <ButtonFav onClick={handleOpenModalFav}><span>⭐</span> Favoritos</ButtonFav>
    <Form>
      <InputContainer>
        <label>{t("withdraw.lbl-payment")}</label>
        <select value={bancoTipo} name="bancoTipo" onChange={handleBanco}>
          <option disabled value="">
            {t("withdraw.input-payment")}
          </option>
          {cuentas &&
            cuentas.filter((item) =>!(item.tipo.toLowerCase() === "pago movil" && moneda.toLowerCase() === "bs.s") )
            .map((item, i) => (
            <option
              key={item.tipo + i}
              value={`${item.tipo.toLowerCase()}-${moneda}`}
            >
              {item.tipo}
            </option>
          ))}
        </select>
      </InputContainer>
      {bancoTipo && (
        <DatosRetiro
          form={form}
          setForm={setForm}
          handleChange={handleChange}
          tipoOperacion={bancoTipo}
          clearForm={clearForm}
        />
      )}

      <ButtonsContainer>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("deposit.btn-cancel")}
        </Button>
        <Button primary={true}
          onClick={solicitarRetiro}
          disabled={form.monto2 < 20000 && monedalocal === "Bs.S"}
        >
          {loading ? t("deposit.loading") : t("deposit.btn-confirm")}
        </Button>
      </ButtonsContainer>
    </Form>

    <ModalFav open={openModalFav} handleClose={handleCloseFav} handleSelect={handleSelectFav} favorites={favorites} handleDelete={handleDeleteFav}/> 
    </>

  );
};

export default FormWithdraw;
